import type { Enums } from "@msuite/utils/types";
import { string, table } from "@rocicorp/zero";

export const ticketType = table("ticketTypes")
	.from("ticket_types")
	.columns({
		id: string(),
		orgId: string().from("org_id"),
		name: string(),
		color: string<Enums<"color">>(),
		icon: string<Enums<"iconName">>(),
		state: string<Enums<"ticketTypeState">>(),
	})
	.primaryKey("id");
